// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3bHSM","header":"ReportDetails_header__1B4hY","title":"ReportDetails_title__xbfSL","left":"ReportDetails_left__2Mv91"};